import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchNavigationBarComponent} from './search-navigation-bar/search-navigation-bar.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {SearchSortingComponent} from './search-sorting/search-sorting.component';
import {ComboBoxDropdownModule, NgDesignSystemModule, SimplePaginationModule} from 'ng-design-system';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {SearchPaginationComponent} from './search-pagination/search-pagination.component';
import {ListNavigationModule, ProductListModule} from '@spartacus/storefront';
import {ResultsListComponent} from './results-list/results-list.component';
import {DcpSearchProductGridModule} from '../dcp-search-product-grid/dcp-search-product-grid.module';
import {FacetFilterComponent} from './search-navigation-bar/facet-filter/facet-filter.component';
import {SortingDropdownComponent} from './sorting-dropdown/sorting-dropdown.component';
import {SearchResultsTitleComponent} from './search-results-title/search-results-title.component';
import {SearchFacetListComponent} from './search-facet-list/search-facet-list.component';
import {DcpPaginationModule} from '../../shared/dcp-pagination/dcp-pagination.module';
import {MobileSearchNavBarComponent} from './search-navigation-bar/mobile-facet-filter/mobile-search-nav-bar.component';
import {CategoriesMenuModule} from '@app/layout/header/categories-menu/categories-menu.module';
import {MobileFacetValueComponent} from './search-navigation-bar/mobile-facet-value/mobile-facet-value.component';
import {A11yModule} from '@angular/cdk/a11y';
import {FormsModule} from '@angular/forms';
import {AutofocusModule} from '@app/directives/autofocus/autofocus.module';
import {SearchFieldComponent} from './search-navigation-bar/search-field/search-field.component';
import {LoadingIndicatorComponent} from '@dcp/configurator';

@NgModule({
  declarations: [
    SearchNavigationBarComponent,
    SearchSortingComponent,
    SearchPaginationComponent,
    ResultsListComponent,
    FacetFilterComponent,
    SortingDropdownComponent,
    SearchResultsTitleComponent,
    SearchFacetListComponent,
    MobileSearchNavBarComponent,
    MobileFacetValueComponent,
    SearchFieldComponent
  ],
  imports: [
    CommonModule,
    NgDesignSystemModule,
    NgbDropdownModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SearchCustomNavigationBarComponent: {
          component: SearchNavigationBarComponent
        },
        SearchCustomSortingComponent: {
          component: SearchSortingComponent
        },
        SearchCustomPaginationComponent: {
          component: SearchPaginationComponent
        },
        SearchCustomResultListComponent: {
          component: ResultsListComponent
        },
      }
    }),
    ListNavigationModule,
    I18nModule,
    ProductListModule,
    SimplePaginationModule,
    DcpPaginationModule,
    DcpSearchProductGridModule,
    ComboBoxDropdownModule,
    CategoriesMenuModule,
    A11yModule,
    FormsModule,
    AutofocusModule,
    LoadingIndicatorComponent
  ],
  exports: [
    SearchNavigationBarComponent,
    SearchSortingComponent,
    SearchPaginationComponent,
    ResultsListComponent,
    MobileFacetValueComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class SearchResultPageModule {
}
